module.exports = __webpack_public_path__ + "img/card.aa3f8725.png";